import React from 'react';
import * as R from 'ramda';

import {getSocialAccountUrl} from 'js/common/social_helper';

import './index.scss';

export default function SocialUsernameLink(props) {
    const {platform, socialLinkId, classes, children} = props;
    const url = getSocialAccountUrl(platform, socialLinkId);
    if (R.isNil(url)) {
        return <a href="#">{children}</a>;
    }
    return (
        <a
            rel="noopener noreferrer"
            className={R.isNil(classes) ? 'social-username-link' : classes}
            href={url}
            target="_blank"
        >
            {children}
        </a>
    );
}



// WEBPACK FOOTER //
// ./components/social_username_link/index.js